<button type="button" nz-button nzSize="default" nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomRight"
  nzType="default">
  <i nz-icon [nzType]="activeOption.icon"></i>
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    <li *ngFor="let option of viewOptions" nz-menu-item (click)="handleViewChange(option.value)"
      [nzDisabled]="option.disabled" [nzSelected]="option.value === view">
      <i nz-icon [nzType]="option.icon"></i>
      <span class="option-label">{{ option.label }}</span>
    </li>
  </ul>
</nz-dropdown-menu>